// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const TimeEntriesPage = lazy(() => import('./pages/TimeEntriesPage'));
const BillableTrackingPage = lazy(() => import('./pages/BillableTrackingPage'));
const TimeReportsPage = lazy(() => import('./pages/TimeReportsPage'));

export const TimeRoutes: RouteObject = {
  path: 'time',
  handle: { crumb: 'Time & Expenses' },
  element: <ModuleGuard moduleId="projects.time" />,
  children: [
    { index: true, element: <Navigate to="time-entries" replace /> },
    { path: 'time-entries', element: <TimeEntriesPage />, handle: { crumb: 'Time Entries' } },
    { path: 'billable-tracking', element: <BillableTrackingPage />, handle: { crumb: 'Billable Tracking' } },
    { path: 'time-reports', element: <TimeReportsPage />, handle: { crumb: 'Time Reports' } },
  ],
};
